<template>
  <AppSection id="timesheet-details" type="page" title="Timesheets">

    <AppSpinner
      v-if="isLoading || isError"
      class="text-secondary mx-auto mt-5"
      size="5"
    />
    <template v-else>


      <TimesheetDetailsHeader
        :status="timesheet.Status || ''"
        :job-title="timesheet.JobTitle || ''"
        :company-name="timesheet.CompanyName || ''"
        :contract-id="timesheet.ContractID || ''"
        :timesheet-id="timesheet.ID || ''"
        :start-date="timesheet.TimesheetStartDate || ''"
        :approvers-names="approversNames || ''"
        :timesheet="timesheet"
      />

      <template v-if="timesheet.Frequency.toLowerCase() === 'monthly'">
        <WeeklyTimesheet
          v-if="isMobileView"
          :timesheet="timesheet"
          :is-mobile-view="isMobileView"
        />
        <MonthlyTimesheet
          v-else
          :timesheet="timesheet"
          :is-mobile-view="isMobileView"
        />
      </template>

      <WeeklyTimesheet
        v-else-if="timesheet.Frequency.toLowerCase() === 'weekly'.toLowerCase()"
        :timesheet="timesheet"
        :is-mobile-view="isMobileView"
      />

    </template>
  </AppSection>
</template>

<script>
  import AppSection from "../../../components/common/sections/AppSection";
  import TimesheetDetailsHeader from "./TimesheetDetailsHeader";
  import TimesheetForm from "./TimesheetForm";
  import {getTimesheet} from "../../../api/timesheet.api";
  import AppSpinner from "../../../components/common/utils/AppSpinner";
  import MonthlyTimesheet from "./MonthlyTimesheet";
  import WeeklyTimesheet from "./WeeklyTimesheet";

  export default {
    name: "index",
    components: {WeeklyTimesheet, MonthlyTimesheet, AppSpinner, TimesheetForm, TimesheetDetailsHeader, AppSection},
    props: {
      timesheet_id: null,
      nav_scope_id: null
    },
    data() {
      return {
        timesheet: null,
        approversNames: [],
        screenWidth: 0,
        isLoading: false,
        isError: false
      }
    },
    computed: {
      isMobileView() {
        return this.screenWidth < this.$getConst.breakpoints.md;
      }
    },
    methods: {
      formatFileName(name) {
        const indexStartName = name.split("_", 2).join("_").length + 1;
        if (indexStartName > name.length) {
          return name;
        }
        return name.substr(indexStartName);
      },
      getTimesheet() {
        this.isLoading = true;
        this.isError = false;
        getTimesheet(this.timesheet_id, this.nav_scope_id).then(
          (response) => {
            this.timesheet = response.data.Timesheet;
            this.timesheet.Approvers.forEach(approver => {
              if (approver.id > 0) {
                this.approversNames.push(approver.name);
              }
            });
            this.timesheet.Attachments.forEach(attachment => {
              attachment.FileName = this.formatFileName(attachment.FileName);
            });
            this.isLoading = false;
          },
          (error) => {
            this.isError = true;
            this.handleApiError(error);
            this.$router.push({name: this.$getConst.routesNames.timesheets});
            this.isLoading =false;
          }
        )
      }
    },
    created() {
      this.getTimesheet();
      window.addEventListener('resize', () => {this.screenWidth = window.innerWidth});
      this.screenWidth = window.innerWidth;
    },
    destroyed() {
      window.removeEventListener('resize', () => {this.screenWidth = window.innerWidth});
    },
  }
</script>

<style scoped>
  .calendar a:hover {
    text-decoration: none;
  }
</style>
